import React from "react";
import DataTable from 'react-data-table-component';

function CountByLocAndYearTable(props) {
    if (props.data === null) {
        return (
            <div className="card my-3 mx-3">
                <div className="card-body d-flex align-items-center justify-content-center">
                    Failed to create visualization
                </div>
            </div>
        )
    }
    else {
        let columns = [];
        if (props.data.length > 0) {
            columns = Object.keys(props.data[0]).map(column => ({
                name: column,
                width: "120px",
                selector: row => row[column]
            }))
        }

        return (
            <div className="card my-3 mx-3">
                <div className="card-body">
                    <h6 className="card-title">Number of Observations for {props.trait} by Location and Year</h6>
                    <DataTable
                        fixedHeader={true}
                        fixedHeaderScrollHeight="400px"
                        columns={columns}
                        data={props.data}
                    />
                </div>
            </div>

        )
    }
}

export default CountByLocAndYearTable;